import React from 'react';
import { ecosystemData } from '../data/mock';

const EcosystemSection = () => {
  return (
    <section className="py-24 bg-slate-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-16">
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-orange-100 rounded-full mb-6">
            <span className="text-sm font-medium text-orange-700">EKIP Holding</span>
          </div>
          <h2 className="text-3xl sm:text-4xl font-bold text-slate-900 mb-4">
            {ecosystemData.title}
          </h2>
          <p className="text-lg text-slate-600">
            {ecosystemData.subtitle}
          </p>
        </div>

        {/* Companies Grid - 5 items */}
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-6">
          {ecosystemData.companies.map((company, index) => (
            <div
              key={index}
              className="group bg-white rounded-2xl p-6 hover:shadow-xl hover:shadow-slate-200/50 transition-all duration-300 border border-slate-100 hover:border-orange-200 text-center"
            >
              <div className="w-20 h-20 mx-auto mb-4 bg-slate-50 rounded-2xl flex items-center justify-center overflow-hidden group-hover:scale-105 transition-transform">
                <img
                  src={company.logo}
                  alt={company.name}
                  className="w-16 h-16 object-contain"
                />
              </div>
              <h3 className="text-base font-bold text-slate-900 mb-1">
                {company.name}
              </h3>
              <p className="text-sm text-slate-500">
                {company.description}
              </p>
            </div>
          ))}
        </div>

        {/* Connection lines visual */}
        <div className="mt-12 text-center">
          <p className="text-slate-500 text-sm">
            Un écosystème intégré pour des solutions complètes
          </p>
        </div>
      </div>
    </section>
  );
};

export default EcosystemSection;
